import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import {
  TogetherAuctionDIPLoanDetails,
  TogetherAuctionDIPApplicantDetails,
} from './../models/api.models';
import { getAPIURL } from './../conf/app.conf';
import * as _ from 'lodash-es';
import * as Base64 from '@together/base64-url';

@Injectable()
export class NodeAPIService {

  /**
   * Creates an instance of NodeAPIService.
   * @param {HTTPClient} http
   * @memberof NodeAPIService
   */
  constructor(private http: HttpClient) { }

  /**
   * Gets loan details for a case.
   *
   * @param {any} case_id
   * @returns
   * @memberof NodeAPIService
   */
  getLoanDetails(case_id) {

    // Get the API URL
    let apiUrl = getAPIURL('get_loan_details');

    // Replace the case ID
    apiUrl = apiUrl.replace(':case_id', case_id);

    // Return observable for the component to listen to and bind, etc.
    return this.http.get(apiUrl);
  }

  /**
   * Copies loan details for a case.
   *
   * @param {any} case_id
   * @returns
   * @memberof NodeAPIService
   */
  copyLoanDetails(caseId) {

    // Get the API URL
    let apiUrl = getAPIURL('copy_loan_details');

    // Replace the case ID
    apiUrl = apiUrl.replace(':case_id', caseId);

    // Return observable for the component to listen to and bind, etc.
    return this.http.get(apiUrl);
  }

  /**
   * Saves loan details.
   *
   * @param {any} loan_details
   * @memberof NodeAPIService
   */
  saveLoanDetails(loan_details) {

    // Save loan details URL.
    let apiUrl = getAPIURL('save_loan_details');

    // Replace case ID
    apiUrl = apiUrl.replace(':case_id', loan_details.CaseId);

    // Return observable to post.
    return this.http.post(apiUrl, loan_details);
  }

  /**
   * Gets applicant details.
   *
   * @param {any} case_id
   * @returns
   * @memberof NodeAPIService
   */
  getApplicantDetails(case_id) {

    // Get applicants
    let apiUrl = getAPIURL('get_applicants');

    // Replace case ID
    apiUrl = apiUrl.replace(':case_id', case_id);

    // Get applicant details
    return this.http.get(apiUrl);
  }

  /**
   * Saves applicant details.
   *
   * @param {any} case_id
   * @param {any} applicant_details
   * @memberof NodeAPIService
   */
  saveApplicantDetails(case_id, applicant_details) {

    // Save loan details URL.
    let apiUrl = getAPIURL('save_applicant_details');

    // Replace case ID
    apiUrl = apiUrl.replace(':case_id', case_id);

    // Return observable to post.
    return this.http.post(apiUrl, applicant_details);
  }

  /**
   * Deletes an applicant.
   *
   * @param {any} case_id
   * @param {any} applicant_id
   * @returns
   * @memberof NodeAPIService
   */
  deleteApplicantDetails(case_id, applicant_id) {

    // Get applicants
    let apiUrl = getAPIURL('delete_applicants');

    // Replace case ID
    apiUrl = apiUrl.replace(':case_id', case_id).replace(':applicant_id', applicant_id);

    // Get applicant details
    return this.http.get(apiUrl);
  }


  /**
   * Deletes an applicant.
   *
   * @param {any} case_id
   * @param {any} applicant_id
   * @returns
   * @memberof NodeAPIService
   */
  deleteApplicantAddress(case_id, address_id) {

    // Get applicants
    let apiUrl = getAPIURL('delete_applicant_address');

    // Replace case ID
    apiUrl = apiUrl.replace(':case_id', case_id).replace(':address_id', address_id);

    // Get applicant details
    return this.http.get(apiUrl);
  }


  /**
   * Save income details.
   *
   * @param {any} case_id
   * @param {any} applicant_id
   * @param {any} income_details
   * @returns
   * @memberof NodeAPIService
   */
  saveIncomeDetails(case_id, applicant_id, income_details) {

    let apiUrl = getAPIURL('save_employment_details');

    // Replace case ID
    apiUrl = apiUrl.replace(':case_id', case_id).replace(':applicant_id', applicant_id);

    return this.http.post(apiUrl, income_details);
  }


  /**
   * Gets income details.
   *
   * @param {any} case_id
   * @param {any} applicant_id
   * @memberof NodeAPIService
   */
  getIncomeDetails(case_id, applicant_id) {
    let apiUrl = getAPIURL('get_employment_details');

    // Replace case ID
    apiUrl = apiUrl.replace(':case_id', case_id).replace(':applicant_id', applicant_id);

    return this.http.get(apiUrl);
  }


  /**
   * Get property details.
   *
   * @param {any} case_id
   * @returns
   * @memberof NodeAPIService
   */
  getPropertyDetails(case_id) {
    let apiUrl = getAPIURL('get_security');

    apiUrl = apiUrl.replace(':case_id', case_id);

    return this.http.get(apiUrl);
  }

  /**
   * Save property details.
   *
   * @param {any} case_id
   * @param {any} property
   * @returns
   * @memberof NodeAPIService
   */
  savePropertyDetails(case_id, security_id, property) {
    security_id = _.isNil(security_id) ? '00000000-0000-0000-0000-000000000000' : security_id;
    let apiUrl = getAPIURL('save_security');
    apiUrl = apiUrl.replace(':case_id', case_id).replace(':security_id', security_id);
    return this.http.post(apiUrl, property);
  }

  submitDIP(case_id) {
    let apiUrl = getAPIURL('submit_dip');
    apiUrl = apiUrl.replace(':case_id', case_id);
    return this.http.get(apiUrl);
  }

  submitQuote(case_id) {
    let apiUrl = getAPIURL('submit_quote');
    apiUrl = apiUrl.replace(':case_id', case_id);
    return this.http.get(apiUrl);
  }

  getDetails(case_id) {
    let apiUrl = getAPIURL('get_details');
    apiUrl = apiUrl.replace(':case_id', case_id);
    return this.http.get(apiUrl);
  }

  saveAddressMatch(addressId, ptcAbsCode) {
    const url = getAPIURL('save_address_match')
      .replace(':address_id', addressId)
      .replace(':code', ptcAbsCode);
    return this.http.get(url);
  }
  searchPostcode(postcode) {
    let apiUrl = getAPIURL('address_search');
    apiUrl = apiUrl.replace(':postcode', postcode);
    return this.http.get(apiUrl);
  }

  getAddress(id) {
    let apiUrl = getAPIURL('address_get');
    apiUrl = apiUrl.replace(':id', id);
    return this.http.get(apiUrl);
  }

  requote(caseId, planName) {
    let apiUrl = getAPIURL('requote_dip');
    apiUrl = apiUrl.replace(':caseid', caseId);
    apiUrl = apiUrl.replace(':planname', Base64.encode(planName));
    return this.http.get(apiUrl);
  }

  /**
   * Tells component if it is new based upon the case_id.
   *
   * @param {any} case_id
   * @returns
   * @memberof NodeAPIEntityService
   */
  isNew(case_id) {
    return case_id === '00000000-0000-0000-0000-000000000000';
  }

}
